<li ngbDropdown class="nav-item dropdown {{ className }}">
  <a
    ngbDropdownToggle
    class="nav-avatar-btn arrow-none"
    id="profileDropdown"
    role="button"
    data-bs-auto-close="outside"
    data-bs-display="static"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    <span class="nav-avatar-circle">
      {{ getInitials((me$ | async)) }}
    </span>
  </a>

  <ul
    ngbDropdownMenu
    class="dropdown-menu dropdown-animation dropdown-menu-end shadow pt-3"
    aria-labelledby="profileDropdown"
  >
    <li class="px-3 mb-3">
      <div class="d-flex align-items-center">
        <div class="nav-avatar-circle me-3" style="width:40px;height:40px;font-size:14px;">
          {{ getInitials((me$ | async)) }}
        </div>
        <div>
          @if (me$ | async; as me) {
            <a class="h6 mt-2 mt-sm-0" routerLink="/user/profile">
              {{ me.name }} {{ me.last_name }}
            </a>
            <p class="small m-0">{{ me.email }}</p>
          } @else {
            <a class="h6 mt-2 mt-sm-0" routerLink="/user/profile">Usuario</a>
            <p class="small m-0"></p>
          }
        </div>
      </div>
    </li>

    <li><hr class="dropdown-divider" /></li>
    <li>
      <a class="dropdown-item" routerLink="/user/profile">
        <i class="bi bi-person fa-fw me-2"></i>Mi Perfil
      </a>
    </li>
    <li>
      <a class="dropdown-item" routerLink="/user/my-purchases">
        <i class="bi bi-bookmark-check fa-fw me-2"></i>Mis Compras
      </a>
    </li>
    <li>
      <a class="dropdown-item bg-danger-soft-hover" (click)="onLogout($event)">
        <i class="bi bi-power fa-fw me-2"></i>Cerrar sesión
      </a>
    </li>
  </ul>
</li>